// Worker Flow Action Types
export const SET_WORKER_CONTRACTOR_INFO = 'worker/SET_CONTRACTOR_INFO';
export const SET_WORKER_WORK_INFO = 'worker/SET_WORK_INFO';
export const SET_WORKER_PERSONAL_INFO = 'worker/SET_PERSONAL_INFO';
export const SET_WORKER_BANK_INFO = 'worker/SET_BANK_INFO';
export const SET_WORKER_RISKY_ACTIVITIES = 'worker/SET_RISKY_ACTIVITIES';
export const SET_WORKER_HAS_RISKY_ACTIVITIES = 'worker/SET_HAS_RISKY_ACTIVITIES';
export const SET_WORKER_MEDICAL_INFO = 'worker/SET_MEDICAL_INFO';
export const SET_WORKER_HAS_MEDICAL_INFO = 'worker/SET_HAS_MEDICAL_INFO';
export const SET_WORKER_BENEFICIARIES = 'worker/SET_BENEFICIARIES';
export const SET_WORKER_HAS_BENEFICIARIES = 'worker/SET_HAS_BENEFICIARIES';
export const SET_WORKER_LEGAL_HEIRS = 'worker/SET_LEGAL_HEIRS';
export const SET_WORKER_FAMILY_GROUP = 'worker/SET_FAMILY_GROUP';
export const SET_WORKER_HAS_FAMILY_GROUP = 'worker/SET_HAS_FAMILY_GROUP';
export const SET_WORKER_PDF_URL = 'worker/SET_PDF_URL';
export const SET_WORKER_FORM_DOCUMENT_URL = 'worker/SET_FORM_DOCUMENT_URL';

export const SET_WORKER_CONTRACTOR_INFO_VALID = 'worker/SET_CONTRACTOR_INFO_VALID';
export const SET_WORKER_WORK_INFO_VALID = 'worker/SET_WORK_INFO_VALID';
export const SET_WORKER_PERSONAL_INFO_VALID = 'worker/SET_PERSONAL_INFO_VALID';
export const SET_WORKER_BANK_INFO_VALID = 'worker/SET_BANK_INFO_VALID';
export const SET_WORKER_RISKY_ACTIVITIES_VALID = 'worker/SET_RISKY_ACTIVITIES_VALID';
export const SET_WORKER_MEDICAL_INFO_VALID = 'worker/SET_MEDICAL_INFO_VALID';
export const SET_WORKER_BENEFICIARIES_VALID = 'worker/SET_BENEFICIARIES_VALID';
export const SET_WORKER_FAMILY_GROUP_VALID = 'worker/SET_FAMILY_GROUP_VALID';

export const SET_WORKER_IS_CLICKED = 'worker/SET_IS_CLICKED';
export const SET_WORKER_CONSENT_CHECK = 'worker/SET_CONSENT_CHECK';
export const SET_WORKER_POLICIES = 'worker/SET_POLICIES';

export const RESET_WORKER_STORE = 'worker/RESET_STORE';
export const RESET_WORKER_BENEFICIARIES = 'worker/RESET_BENEFICIARIES';
